export default "__VITE_ASSET__DwRHh0Sn__"